import type { DataSourceType, CalculateModeType, CumulativeTableData } from './types';

const SORTED_DATASOURCES: DataSourceType[] = ['appannie', 'sensortower'];

const getSortedDataSources = (dataSources: DataSourceType[]): DataSourceType[] => {
  if (!Array.isArray(dataSources)) return [];
  return dataSources.sort((a, b) => {
    const aIndex = SORTED_DATASOURCES.indexOf(a);
    const bIndex = SORTED_DATASOURCES.indexOf(b);
    return aIndex - bIndex;
  });
};

export const getCumulativeTableData = (games: any[]): CumulativeTableData => {
  if (!Array.isArray(games))
    return {
      mode: 'sum',
      games: [],
      dataSources: [],
    };

  const dataSources: DataSourceType[] = [];
  let mode: CalculateModeType = 'sum';

  try {
    for (const gameTemp of games) {
      const cumulativeDataTemp = gameTemp?.total;
      if (!Array.isArray(cumulativeDataTemp)) continue;
      for (const cumulativeDataItemTemp of cumulativeDataTemp) {
        const dataSourceTemp = cumulativeDataItemTemp?.source;
        if (!dataSourceTemp) continue;
        if (cumulativeDataItemTemp?.mode) {
          mode = cumulativeDataItemTemp?.mode;
        }
        if (!dataSources.includes(dataSourceTemp)) {
          dataSources.push(dataSourceTemp);
        }
      }
    }
  } catch (exception) {
    console.warn(exception);
  }

  return {
    mode,
    games,
    dataSources: getSortedDataSources(dataSources),
  };
};
